import { formatDate } from '../lib/money';
import type { RpcSummary } from '../lib/rpc-client';
import { useSaveCard } from './RpcUi';

/** Whether to ask for a card: a postpaid plan with none on file. A suspended
 *  account has its own banner, and on the way back from saving one the
 *  overview's notice says it shows once Stripe confirms it. */
export function asksForCard(s: RpcSummary, justSaved: boolean): boolean {
  return !!s.plan.postpaid && !s.billing.card_on_file && s.state !== 'suspended' && !justSaved;
}

/** A postpaid plan with no card: the RPC refuses its keys until one is saved
 *  (saas sends the state `card_required`), so every account page but billing,
 *  which has its own button, asks for one first. */
export function AddCard({ s }: { s: RpcSummary }) {
  const { busy, error, save } = useSaveCard();
  return (
    <section className="rpc-notice rpc-notice--warn rpc-add-card" data-testid="add-card">
      <div className="rpc-add-card-row">
        {s.state === 'card_required' ? (
          <p>
            <strong>Your keys don't work yet.</strong> Your plan is invoiced monthly to a card
            on file, and the RPC refuses your keys until one is saved.
          </p>
        ) : (
          <p>
            <strong>Add a card for your invoices.</strong> Your plan is invoiced monthly. This
            period's usage is invoiced on {formatDate(s.period.end)}.
          </p>
        )}
        <button
          className="btn btn-primary"
          type="button"
          onClick={save}
          disabled={busy}
          data-testid="add-card-button"
        >
          {busy ? 'Opening Stripe…' : 'Add a card'}
        </button>
      </div>
      {error && <p className="form-error">{error}</p>}
    </section>
  );
}
